import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {VueMasonryPlugin} from 'vue-masonry';
// import 'cropperjs/dist/cropper.min.css'
// import 'cropperjs/dist/cropper.min.js'


Vue.use(VueMasonryPlugin)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
